import Badge from './Badge';
import { BadgeItemProps } from './Badge.types';

export const BadgeItem = ({ shallShowBadge = true, color, dataTestId, label }: BadgeItemProps) => {
  if (!shallShowBadge) return null;

  return (
    <Badge color={color} dataTestId={dataTestId}>
      {label}
    </Badge>
  );
};
